import React, { useEffect } from "react";
import { useState } from "react";
import compose from "recompose/compose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import MerchantListFilter from "./components/MerchantListFilter";
import MerchantListTable from "./components/MerchantListTable";
import { db } from "firebase/client";
// mui
import { Card, Hidden, Typography } from "@material-ui/core";

// components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

// styling
import Style from "assets/jss/material-dashboard-pro-react/views/reportsStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import Loader from "components/Loader/Loader";

const headers = [
    { label: "Merchant #", key: "merchantNumber" },
    { label: "Merchant Name", key: "name" },
    { label: "Available Points", key: "quantity" },
    { label: "Pending Points", key: "pointsEarned" },
    { label: "", key: "action" },
];

export function MerchantList(props) {
    const { classes, history, userCompany } = props;
    const itemsPerPage = 9;
    const [pageNumber, setPageNumber] = useState(0);
    const [index, setIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(itemsPerPage);
    const [data, setData] = useState(false);
    const [merchantList, setMerchantList] = useState(false);
    const [copyArr, setCopyArr] = useState([]);
    const [searchString, setSearchString] = useState("");

    const numberFormatter = new Intl.NumberFormat("en-US", {});

    const handlePageClick = ({ selected }) => {
        setPageNumber(selected);
        setIndex(selected * itemsPerPage);
        setEndIndex(selected * itemsPerPage + itemsPerPage);
    };

    const handleSearch = () => {
        if (searchString) {
            const filtered = copyArr.filter((f) => {
                if (f.companyName.toLowerCase().includes(searchString.toLowerCase())) {
                    return true;
                }
                if (
                    f.merchantId && f.merchantId.toLowerCase().includes(searchString.toLowerCase())
                ) {
                    return true;
                }
            });
            setMerchantList(filtered);
        } else {
            setMerchantList(copyArr);
        }
    };

    const getData = () => {
        let merchantArr = [];
        return db
            .collection("users")
            .where("IsoAdminCompanyName", "==", userCompany)
            .get()
            .then((snapshots) => {
                if (!snapshots.empty) {
                    snapshots.forEach((s) => {
                        s = s.data();
                        if (s.deactivated !== true) {
                            merchantArr.push(s);
                        }
                        
                    });
                    setMerchantList(merchantArr)
                    setCopyArr(merchantArr)
                    setData(true)
                } else {
                    setData([]);
                }
            })
    };

    useEffect(() => {
        if (!data) {
            getData();
        }
    }, []);

    if (!data || !merchantList) return <Loader />;

    return (
        <div>
            <Hidden mdUp implementation="css">
                <div>
                    <Typography
                        variant="h2"
                        className={classes.title}
                        style={{ color: "#1A405F" }}
                    >
                        Please View Page on Desktop / Laptop
                    </Typography>
                </div>
            </Hidden>

            <Hidden smDown implementation="css">
                <GridContainer>
                    <GridItem xs={12}>
                        <Typography variant="h2" className={classes.title}>
                            Reports
                        </Typography>
                    </GridItem>

                    <GridItem xs={12} style={{ marginTop: "20px" }}>
                        <Card style={{ padding: "25px 20px 5px" }}>
                            <GridContainer>
                                <GridItem xs={12}>
                                    {merchantList.length > 0 ? (
                                        <MerchantListFilter
                                            searchString={searchString}
                                            setSearchString={setSearchString}
                                            handleSearch={handleSearch}
                                        />
                                    ) : null}
                                </GridItem>

                                <GridItem xs={12}>
                                    <MerchantListTable
                                        history={history}
                                        data={merchantList}
                                        pageNumber={pageNumber}
                                        index={index}
                                        endIndex={endIndex}
                                        itemsPerPage={itemsPerPage}
                                        handlePageClick={handlePageClick}
                                        headers={headers}
                                        numberFormatter={numberFormatter}
                                    />
                                </GridItem>
                            </GridContainer>
                        </Card>
                    </GridItem>
                </GridContainer>
            </Hidden>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        userId: state.auth.user.uid,
        userType: state.auth.user.userType,
        user: state.auth.user,
        userCompany: state.auth.user.companyName,
    };
}

function mapDispatchToProps(actions) {
    return (dispatch) => ({});
}

export default withRouter(
    compose(
        connect(mapStateToProps, mapDispatchToProps),
        withStyles(Style)
    )(MerchantList)
);
